// extracted by mini-css-extract-plugin
export var typeLarge = "FooterMenu-module--type-large--841EI";
export var typeMedium = "FooterMenu-module--type-medium--+fiwe";
export var typeBody = "FooterMenu-module--type-body--0c1zx";
export var homeIcon = "FooterMenu-module--home-icon--b7VS7";
export var footerMenu = "FooterMenu-module--footer-menu--+sPTZ";
export var footerMenuRight = "FooterMenu-module--footer-menu-right--JtjMI";
export var buttonLinks = "FooterMenu-module--button-links--ak5O-";
export var utilityMenu = "FooterMenu-module--utility-menu--UTbbK";